ready = ->
  $("body").on "click", ".add-manufacture-btn", (e) ->
    $('#register_manufacture').removeClass 'hide'
    $('#edit_manufacture, #edit_vaccine, #register_vaccine').addClass 'hide'

  $("body").on "click", ".edit-manufacture-btn", (e) ->
    $('#edit_manufacture').removeClass 'hide'
    $('#register_manufacture, #edit_vaccine, #register_vaccine').addClass 'hide'

$(document).on 'turbolinks:load', ready